import React, { useEffect, useState } from 'react';
import { collection, getCountFromServer, query, where } from 'firebase/firestore';
import { db } from '../../firebase-config';

const cardStyle = {
  background: 'rgba(255,255,255,0.03)',
  border: '1px solid rgba(0,150,255,0.12)',
  borderRadius: '10px',
  padding: '20px',
};

const labelStyle = {
  color: 'rgba(140,185,240,0.7)',
  fontSize: '0.72rem',
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
};

const valueStyle = {
  color: '#7eb8f7',
  fontSize: '1.9rem',
  fontWeight: 800,
  marginTop: '8px',
};

function DataManagement() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState({
    briefs: 0,
    pendingRequests: 0,
    staff: 0,
    intrusions: 0,
  });

  useEffect(() => {
    let mounted = true;

    async function loadStats() {
      setLoading(true);
      setError('');
      try {
        const [briefsSnap, pendingSnap, staffSnap, intrusionsSnap] = await Promise.all([
          getCountFromServer(collection(db, 'project_briefs')),
          getCountFromServer(query(collection(db, 'access_requests'), where('status', '==', 'pending'))),
          getCountFromServer(collection(db, 'authorized_users')),
          getCountFromServer(collection(db, 'security_logs')),
        ]);

        if (!mounted) return;
        setStats({
          briefs: briefsSnap.data().count,
          pendingRequests: pendingSnap.data().count,
          staff: staffSnap.data().count,
          intrusions: intrusionsSnap.data().count,
        });
      } catch (err) {
        if (!mounted) return;
        setError(err?.message || 'Unable to load data metrics.');
      } finally {
        if (mounted) setLoading(false);
      }
    }

    loadStats();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#080e1a', color: '#e0eaff' }}>
      <div className="container-app py-12">
        <div className="flex items-center justify-between mb-8 gap-4 flex-wrap">
          <h1 className="text-4xl font-bold">Data Management</h1>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-md border"
            style={{ borderColor: 'rgba(0,170,255,0.45)', color: '#9fd2ff' }}
          >
            Refresh
          </button>
        </div>

        {error && (
          <div className="mb-6 p-4 rounded-md" style={{ background: 'rgba(255,80,80,0.12)', border: '1px solid rgba(255,80,80,0.35)' }}>
            {error}
          </div>
        )}

        <div className="grid gap-4 mb-8" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
          <div style={cardStyle}>
            <div style={labelStyle}>Project Briefs</div>
            <div style={valueStyle}>{loading ? '--' : stats.briefs}</div>
          </div>
          <div style={cardStyle}>
            <div style={labelStyle}>Pending Access</div>
            <div style={valueStyle}>{loading ? '--' : stats.pendingRequests}</div>
          </div>
          <div style={cardStyle}>
            <div style={labelStyle}>Active Staff</div>
            <div style={valueStyle}>{loading ? '--' : stats.staff}</div>
          </div>
          <div style={cardStyle}>
            <div style={labelStyle}>Purgatory Hits</div>
            <div style={valueStyle}>{loading ? '--' : stats.intrusions}</div>
          </div>
        </div>

        <div className="grid gap-4" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
          <a href="/pages/HR.html" target="_blank" rel="noreferrer" style={cardStyle}>
            <div className="text-xl font-semibold mb-2">HR Operations</div>
            <div style={{ color: 'rgba(160,200,245,0.8)' }}>Review pending access, active staff, and intrusion logs.</div>
          </a>

          <a href="/pages/data_viewer.html?title=Analyzed%20Inventory&src=/data/analyzed_inventory.csv" target="_blank" rel="noreferrer" style={cardStyle}>
            <div className="text-xl font-semibold mb-2">Analyzed Inventory</div>
            <div style={{ color: 'rgba(160,200,245,0.8)' }}>Open current analyzed inventory CSV in the built-in data viewer.</div>
          </a>

          <a href="/pages/data_viewer.html?title=Site%20History&src=/data/site_history.csv" target="_blank" rel="noreferrer" style={cardStyle}>
            <div className="text-xl font-semibold mb-2">Site History</div>
            <div style={{ color: 'rgba(160,200,245,0.8)' }}>Inspect productive and unproductive sources used by the pipeline.</div>
          </a>

          <a href="/pages/internal_dashboard.html" target="_blank" rel="noreferrer" style={cardStyle}>
            <div className="text-xl font-semibold mb-2">Inventory Dashboard</div>
            <div style={{ color: 'rgba(160,200,245,0.8)' }}>Launch the internal inventory intelligence dashboard.</div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default DataManagement;
